import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CBHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-485">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/b4jwWECnVSBTrTbEmDTuHV/Clear-Brilliant-.jpg)'
    }} data-id="element-486" />
      <div className="absolute inset-0 bg-black/60" data-id="element-487" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-488">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-489">
          <div className="mb-6" data-id="element-490">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-491">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-492">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-493">
            Be DAZZLING
          </span>

          <h1 className="text-[30px] sm:text-5xl lg:text-[56px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-494">
            CLEAR + BRILLIANT TOUCH
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-495">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-496">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-497">
              <em data-id="element-498">"The description is in the name!"</em> For clear and brilliant
              skin, this laser treatment is a must.{' '}
              <em data-id="element-499">
                "It has no downtime and will keep your skin clear and flawless,
                and exuding brilliance!"
              </em>{' '}
              says Dr. Fiona.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-500">
              This treatment is perfect for reducing pore size, improving
              texture and generally keeping your skin looking beautiful.{' '}
              <em data-id="element-501">
                "I love this treatment because it's safe for all skin tones and
                types, thanks to its customizable, dual-wavelength technology,"
              </em>{' '}
              explains Dr. Fiona.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-502">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}